import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "2",
      y: "2",
      width: "16",
      height: "16",
      rx: "4",
      fill: "#1E164B"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.7151 11.23C12.7151 10.0983 11.8401 9.45667 10.6618 9.14167L9.81012 8.92001C9.02846 8.71001 8.97012 8.30167 8.97012 8.09167C8.97012 7.57834 9.41346 7.19334 10.0318 7.19334C10.3908 7.19334 10.6803 7.32478 10.8638 7.54478C11.1148 7.84575 11.4036 8.20834 11.7955 8.20834C12.1767 8.20834 12.5017 7.896 12.3951 7.53002C12.193 6.8359 11.6515 6.32241 10.8983 6.1069C10.636 6.03184 10.4285 5.80872 10.4285 5.53588V5.39667C10.4285 5.1776 10.2509 5.00001 10.0318 5.00001C9.81272 5.00001 9.63512 5.1776 9.63512 5.39667V5.54286C9.63512 5.81359 9.4333 6.03739 9.17438 6.1165C8.23479 6.40358 7.54679 7.13885 7.54679 8.12667C7.54679 8.74501 7.82679 9.70167 9.41346 10.11L10.3235 10.3667C11.0118 10.5533 11.3035 10.8917 11.3035 11.3C11.3035 11.825 10.8951 12.2567 10.1601 12.2567C9.69197 12.2567 9.33757 12.086 9.1257 11.8239C8.88139 11.5216 8.58505 11.1717 8.1964 11.1717C7.81066 11.1717 7.48441 11.4908 7.60755 11.8564C7.82787 12.5104 8.37612 13.04 9.15388 13.2812C9.42422 13.3651 9.63512 13.5987 9.63512 13.8818V14.0533C9.63512 14.2724 9.81272 14.45 10.0318 14.45C10.2509 14.45 10.4285 14.2724 10.4285 14.0533V13.9098C10.4285 13.6284 10.6465 13.3996 10.92 13.3334C11.9662 13.0799 12.7151 12.3047 12.7151 11.23Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }